export default __webpack_public_path__ + "static/media/amole.e30eda00.webp";